// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '0a4e650227f11bcca2cbd57fa28243e423659c14';
export const BUILD_NUMBER = '264';
export const BUILD_TIMESTAMP = '2026-10-07T06:14:38.408Z';
